<div class="jumbotron">
    <h1 class="text-center">
        {{
            i18n._7228_QUARTERLY_PERFORMANCE___DEVELOPMENT_CHECK_IN_FORM
                | translate
        }}
    </h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="tdcf-content">
    <cmps-wait-status *ngIf="state?.pending"></cmps-wait-status>

    <ng-container *ngIf="!state?.pending && state?.metadata != null">
        <ng-container
            *ngIf="state?.info?.manager || state?.info?.team?.length !== 0"
        >
            <h2>{{ i18n._7224_HIERARCHY | translate }}</h2>
            <div
                cmpsTdcfSearch
                [currentUserId]="userId"
                [info]="state?.hierarchy"
            ></div>
        </ng-container>

        <ng-container *ngIf="state?.info?.manager?.userId != null">
            <h2>{{ i18n._7225_SELF_REVIEW | translate }}</h2>
            <div
                cmpsTdcfTable
                [mode]="Mode.MEMBER"
                [templateId]="templateId"
                [metadata]="state?.metadata"
                [info]="state?.info"
            ></div>
        </ng-container>

        <ng-container *ngIf="state?.info?.team?.length !== 0">
            <h2>{{ i18n._925_MY_TEAM | translate }}</h2>
            <div
                cmpsTdcfTable
                [mode]="Mode.MANAGER"
                [templateId]="templateId"
                [metadata]="state?.metadata"
                [info]="state?.info"
            ></div>
        </ng-container>
    </ng-container>
</div>
